"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getTotalEligibleExposure = ({ concentrationReceivables, }) => {
    return _.sumBy(concentrationReceivables, (receivable) => receivable.eligibilityFields.eligibleExposure);
};
const getConcentrationLimitValue = ({ concentrationReceivables, principalBalance, }) => {
    // if principal balance >= 25M, concentration limit is 17.5%
    if (principalBalance >= 25_000_000) {
        return 0.175;
    }
    // if principal balance < 25M, use greater of 25% concentration limit or $3.5M concentration amount
    const baseConcentrationLimit = 0.25;
    const concentrationAmountLimit = 3_500_000;
    const totalEligibleExposure = getTotalEligibleExposure({
        concentrationReceivables,
    });
    // convert the $3.5M concentration amount ceiling to a concentration limit based on the total eligible exposure of all receivables
    const concentrationLimitByAmount = common_1.utils.divideByOrZero(concentrationAmountLimit, totalEligibleExposure);
    return Math.max(baseConcentrationLimit, concentrationLimitByAmount);
};
exports.concentrationLimitPointerMethods = [
    // at any time the aggregate principal amount outstanding under the Term Loans is
    // (1) less than $25,000,000, no more than the greater of (x) $3,500,000 or (y) 25% (as determined by aggregate Account Balance) of Eligible Accounts in the Financed Portfolio shall relate to any single Client,
    // or (2) equal to or greater than $25,000,000, no more than 17.5% (as determined by aggregate Account Balance) of Eligible Accounts in the Financed Portfolio shall relate to any single Client
    {
        method: 'lunrI801.singleClient',
        pointerImplementation: ({ concentrationReceivables, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(concentrationReceivables.length, new common_1.error.FinleyError(`expected concentrationReceivables to not be an empty array`));
            const { principalBalance, } = concentrationReceivables[0].dynamicIntermediateFields;
            (0, common_1.finleyAssert)(_.isNumber(principalBalance), new common_1.error.FinleyError(`expected principalBalance to be a number but got ${principalBalance}`));
            // lunrI801 concentration limit is based on current principal balance
            // which needs to be configured as an intermediate calc
            const concentrationLimit = getConcentrationLimitValue({
                concentrationReceivables,
                principalBalance,
            });
            const groupingBaseField = 'company_id';
            (0, common_1.finleyAssert)(_.every(concentrationReceivables, (rec) => _.isString(rec.baseFields[groupingBaseField])), new common_1.error.FinleyError(`baseFields.${groupingBaseField} must be defined to run lunrI801.singleClient`));
            const groupedByBaseField = _.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingBaseField]);
            const standardBorrowingBaseReductions = _.map(_.entries(groupedByBaseField), ([, receivables]) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType: 'percentage',
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = { ...result };
                // add in concentrationAmount if over limit, cannot do in toPairs below since it will count the amount multiple times
                if (calculations.concentration > calculations.concentrationLimit) {
                    concentrationAmount += calculations.concentrationAmount || 0;
                }
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map